import axios from 'axios'
import { useCookies } from "vue3-cookies"
import router from '@/router'
import { useMainStore } from "@/stores/MainStore"

const axiosErrorMessageHelper = (error, message) => error?.response?.data?.error || error?.response?.data?.message || message

const axiosIns = axios.create({
// You can add your headers here
// ================================
  baseURL: import.meta.env.VITE_APP_BE_URL,

// timeout: 1000,
// headers: {'X-Custom-Header': 'foobar'}
})

// ℹ️ Add request interceptor to send the authorization header on each subsequent request after login
axiosIns.interceptors.request.use(config => {
  // Retrieve token from localStorage
  const { cookies } = useCookies()
  const JWtoken = cookies.get("jwt")

  // If token is found
  if (JWtoken) {
    // Get request headers and if headers is undefined assign blank object
    config.headers = config.headers || {}

    // Set authorization header
    // ℹ️ JSON.parse will convert token to string
    config.headers.Authorization = JWtoken ? `Bearer ${JWtoken}` : ''
  }

  // Return modified config
  return config
})

// ℹ️ Add response interceptor to handle error and success response
axiosIns.interceptors.response.use(response => {
  const mainStore = useMainStore()
  if (response.config.method !== "get") {
    mainStore.isSnackbarTopVisible = true
  }
  
  return response
}, error => {
  const mainStore = useMainStore()

  console.error(error)
  mainStore.isErrorMessage = true
  mainStore.isSnackbarTopVisible = true

  // Handle error
  switch (error.response.status) {
  case 400:
    console.log(error.response)
    mainStore.addMessage('error', axiosErrorMessageHelper(error, 'Error 400. Bad request.'))
    break
  case 401:
    mainStore.addMessage('error',  axiosErrorMessageHelper(error, 'Unauthorised access. Please try to login again.'))

    // ℹ️ Logout user and redirect to login page
    // Remove "userData" from localStorage
    localStorage.removeItem('userData')
    localStorage.removeItem('jwt')

    // Remove "accessToken" from localStorage
    localStorage.removeItem('accessToken')
    localStorage.removeItem('userAbilities')

    // If 401 response returned from api
    router.push('/login')
    break
  case 403:
    mainStore.addMessage('error', axiosErrorMessageHelper(error, 'Access forbidden. Please check your permissions.'))
    break
  case 404:
    mainStore.addMessage('error', axiosErrorMessageHelper(error, 'Error 404. Request not found.'))
    break
  case 422:
    mainStore.addMessage('error', axiosErrorMessageHelper(error, 'Error 422. Invalid content.'))
    break
  case 429:
    mainStore.addMessage('error', axiosErrorMessageHelper(error, 'Too many requests. Please wait and try again.'))
    break
  case 500:
    mainStore.addMessage('error', axiosErrorMessageHelper(error, 'Server error. Please try again.'))
    break
  case 504:
    mainStore.addMessage('error', axiosErrorMessageHelper(error, 'Error. Gateway timeout.'))
    break
  default : break
  }

  return Promise.reject(error)

})
export default axiosIns
